import * as T from "react";
import { g as C, c as B } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { i as S } from "./index-BFVfkEeQ.mjs";
import { m as w } from "./memoTheme-BzXKG_-k.mjs";
import { c as j } from "./createSimplePaletteValueFilter-B7--0ryQ.mjs";
import { g as R } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { j as W } from "./jsx-runtime-3tyXYecC.mjs";
import { s as M, u as P, c as O } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { c as l } from "./tss-DN0acMKN.mjs";
function U(r) {
  return C("MuiTypography", r);
}
const k = R("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), A = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, $ = S(), D = (r) => {
  const {
    align: o,
    gutterBottom: t,
    noWrap: e,
    paragraph: p,
    variant: s,
    classes: i
  } = r, a = {
    root: ["root", s, r.align !== "inherit" && `align${l(o)}`, t && "gutterBottom", e && "noWrap", p && "paragraph"]
  };
  return O(a, U, i);
}, E = M("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (r, o) => {
    const {
      ownerState: t
    } = r;
    return [o.root, t.variant && o[t.variant], t.align !== "inherit" && o[`align${l(t.align)}`], t.noWrap && o.noWrap, t.gutterBottom && o.gutterBottom, t.paragraph && o.paragraph];
  }
})(w(({
  theme: r
}) => {
  var o;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(r.typography).filter(([t, e]) => t !== "inherit" && e && typeof e == "object").map(([t, e]) => ({
      props: {
        variant: t
      },
      style: e
    })), ...Object.entries(r.palette).filter(j()).map(([t]) => ({
      props: {
        color: t
      },
      style: {
        color: (r.vars || r).palette[t].main
      }
    })), ...Object.entries(((o = r.palette) == null ? void 0 : o.text) || {}).filter(([, t]) => typeof t == "string").map(([t]) => ({
      props: {
        color: `text${l(t)}`
      },
      style: {
        color: (r.vars || r).palette.text[t]
      }
    })), {
      props: ({
        ownerState: t
      }) => t.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: t
      }) => t.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: t
      }) => t.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: t
      }) => t.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), f = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, q = /* @__PURE__ */ T.forwardRef(function(o, t) {
  const {
    color: e,
    ...p
  } = P({
    props: o,
    name: "MuiTypography"
  }), s = !A[e], i = $({
    ...p,
    ...s && {
      color: e
    }
  }), {
    align: a = "inherit",
    className: g,
    component: h,
    gutterBottom: x = !1,
    noWrap: d = !1,
    paragraph: c = !1,
    variant: n = "body1",
    variantMapping: y = f,
    ...m
  } = i, u = {
    ...i,
    align: a,
    color: e,
    className: g,
    component: h,
    gutterBottom: x,
    noWrap: d,
    paragraph: c,
    variant: n,
    variantMapping: y
  }, b = h || (c ? "p" : y[n] || f[n]) || "span", v = D(u);
  return /* @__PURE__ */ W.jsx(E, {
    as: b,
    ref: t,
    className: B(v.root, g),
    ...m,
    ownerState: u,
    style: {
      ...a !== "inherit" && {
        "--Typography-textAlign": a
      },
      ...m.style
    }
  });
});
export {
  q as T,
  k as t
};
//# sourceMappingURL=Typography-DfkimCSn.mjs.map
